exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hiddenField{\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep .ui-calendar-button\r\n{\r\n    border-top-left-radius: 5px!important;\r\n    border-top-right-radius: 0px!important;\r\n    border-bottom-left-radius: 5px!important;\r\n    border-bottom-right-radius: 0px!important;\r\n}\r\n\r\n:host ::ng-deep .ui-calendar .ui-inputtext\r\n{\r\n    border-right: 1px solid!important;\r\n    border-right-color: #a6a6a6!important;\r\n    border-top-right-radius: 5px!important;\r\n    border-bottom-right-radius: 5px!important;\r\n    border-top-left-radius: 0px!important;\r\n    border-bottom-left-radius: 0px!important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/file-status/file-status.component.css
// module id = ../../../../../src/app/file-status/file-status.component.css
// module chunks = main